import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

initializeApp({
    apiKey: "AIzaSyCT3xpv16yJqWcxrw1776rY1nN-GQYE3c8",
    authDomain: "dr-makhwanya-app.firebaseapp.com",
    projectId: "dr-makhwanya-app",
    storageBucket: "dr-makhwanya-app.appspot.com",
    messagingSenderId: "80782511880",
    appId: "1:80782511880:web:0d644f68eda921b06ae6bd",
    measurementId: "G-MGEFETQMN7"
})

export const db = getFirestore()
export const auth = getAuth()